import React from 'react';
import {Navigate} from "react-router-dom";
import {useAuthorization} from "../hooks/useAuthorization";

/**
 * A route guard that checks authorization for a specific component/page.
 * If the user is not authorized, it redirects them to a safe fallback page.
 *
 * @param {object} props
 * @param {React.Component} props.component - The page component that defines the abilities.
 * @param {string} props.action - The minimum action required to access this route (e.g., 'read').
 * @param {React.ReactNode} props.children - The page component to render if authorized.
 */
const ProtectedRoute = ({ component, action, children }) => {
    const { can } = useAuthorization(component);

    if (can(action)) {
        // If authorized, render the page.
        return children;
    }

    // If not authorized, redirect to the main dashboard or a "forbidden" page.
    // This provides a solid guarantee against direct URL access.
    return <Navigate to="/" replace />;
};

export default ProtectedRoute;